/**
 * editAssignmentServiceModule 新建/编辑任务服务
 * Author Qian.qianchen 2019-07-12
 */
'use strict';
angular.module('groupAssignmentServiceModule', ['addExecutorModule'])
    .factory('groupAssignmentService', ["$modal", "$q", function($modal, $q) {
        return {
            /**
             * [initAssignmentData description] 任务数据
             * @return {[type]} [description]
             */
            initAssignmentData: function() {
                return {
                    "TaskCommandId": 0,
                    "TaskName": "",
                    "TaskTime": "",
                    "TaskAddress": "",
                    "Content": "",
                    "UserIds": "",
                    "Remarks": "",
                    "Address": "",
                    "IsMine": 0
                }
            },
            /**
             * [addExecutor description] 添加执行人
             * @param {[type]} $scope [description]
             */
            addExecutor: function($scope) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/taskAssignment/editAssignment/services/addExecutor/addExecutor_tpl.html",
                    scope: $scope,
                    windowClass: "editor_window_class",
                    backdrop: false,
                    controller: "addExecutorCtrl",
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            }
        }
    }]);